<template>
  <div>
    <Modal title="配置编辑">
      <Form ref="configForm" :model="configForm">

      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'stack-container-config-edit',
  data () {
    return {
      configForm: {}
    }
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
